<template>
  <v-chip :color="active ? 'success' : 'grey'" :size="size" :variant="variant">
    {{ active ? $t('status.active') : $t('status.inactive') }}
  </v-chip>
</template>

<script>
/**
 * The recurring active/inactive chip shown in list and detail tables - one
 * place to change the colors/labels for that status across the whole app.
 */
export default {
  name: 'StatusChip',

  props: {
    active: {
      type: Boolean,
      default: false
    },
    size: {
      type: String,
      default: 'small'
    },
    variant: {
      type: String,
      default: undefined
    }
  }
};
</script>
